import {Control} from '../Control.js';
import Library from '../Library.js';

export class LevelSlider extends Control {
    slider = undefined;
    levels = [];
    changeCallback = undefined;

    constructor( map, settings = {} ){
        console.info( 'level_slider', settings );
        settings['name'] = "level_slider";
        if( settings['target'] == undefined ) settings['target'] = "level_slider";
        if( settings['value'] == undefined ) settings['value'] = 0;
        let onchange = undefined;
        if( settings['onchange'] != undefined ){ onchange = settings['onchange']; delete settings['onchange']; };
        super( map, settings );
        if( settings['levels'] != undefined )
            this.levels = settings.levels; delete settings.levels;
        if( onchange ) this.changeCallback = onchange;

        this.getState();

        let div = document.getElementById( this.target );
        if( div == undefined) return;

        let ind = this.getLevel(settings['value']);
        if( this.map.level != undefined )
            ind = this.getLevel(this.map.level);
        let val;
        if( val = this.map.search.get('level'))
            ind = this.getLevel(val);

        this.slider = document.createElement('input');
        this.slider.id = 'level_slider_range';
        this.slider.type = 'range';
        this.slider.min = 0;
        this.slider.max = this.levels.length-1;
        this.slider.value = this.levels.length-ind-1;
        this.slider.step = 1;
        this.map.level = this.levels[ind];
        this.slider.addEventListener('change', this.change.bind(this) );
        this.slider.addEventListener('input', this.slide.bind(this) );
        div.appendChild(this.slider);
        let elem = document.getElementById( "level_slider_value" );
        if( elem ) elem.innerHTML = this.levels[this.slider.max-this.slider.value];

        this.setLabels();
    }

    getLevel( val ){
        for( let i = 0; i < this.levels.length; i++ ){
            if( this.levels[i] == val )
                return i;
        }
        return 0;
    }

    setLabels(){
        document.querySelectorAll('.level_slider_tick').forEach(el => el.remove());
        document.querySelectorAll('.level_slider_val').forEach(el => el.remove());

        let div = document.getElementById( this.target );
        if( div == undefined) return 0;

        let vals = this.slider.max - this.slider.min;
        let thumb = 5;
        let xlen = 100-thumb;
        let t = 0;
        for( let i = 0; i < this.levels.length; i++ ){
            // Add ticks
            let el = document.createElement('label');
            el.className = 'level_slider_tick';
            el.textContent = '-';
            el.setAttribute('ind', i);
            el.style.bottom = (t / vals * xlen + thumb/2) + '%';
            el.addEventListener('click', (e) => { 
                    let ind = e.target.attributes.ind.value;
                    let elem = document.getElementById( "level_slider_range" );
                    elem.value = parseInt(ind); 
                    this.change(ind) 
                    });
            div.appendChild(el);
            // Add labels
            let el2 = document.createElement('label');
            el2.className = 'level_slider_val';
            el2.textContent = this.levels[i];
            el2.setAttribute('ind', i);
            el2.style.bottom = (t / vals * xlen + thumb/2) + '%';
            el2.addEventListener('click', (e) => { 
                    let ind = e.target.attributes.ind.value; 
                    let elem = document.getElementById( "level_slider_range" );
                    elem.value = parseInt(ind);
                    this.change(ind) 
                    });
            div.appendChild(el2);
            t++;
        }
    }

    increment(inc){
        let elem = document.getElementById( "level_slider_range" );
        let val = this.slider.max-parseInt(elem.value);

        if( inc != 0 )
            val = val + inc;
        else
            val = this.levels.length-1;
        if( val < 0 ) val = 0;
        if( val >= this.levels.length ) val = this.levels.length-1;
        elem.value = val;
        this.change(val);
    }

    change( event, ui ){
        console.info( "level change", event, ui );
        let value = event;
        if( event.target ){
            value = this.levels.length-parseInt( event.target.value )-1;
        } else {
            let elem = document.getElementById( "level_slider_range" );
            elem.value = this.levels.length-value-1;
        }

        if( value < 0 ) value = 0;
        if( value >= this.levels.length ) value = this.levels.length-1;
        this.map.level = this.levels[value];
        let elem = document.getElementById( "level_slider_value" );
        if( elem ) elem.innerHTML = this.levels[value];
        for( let lay in this.map.layers ){
            if( this.map.layers[lay].dynamic['level'] ){
                this.map.layers[lay].updateLevel();
            }
        }
            
        this.changeCallback(value, this.levels[value]);
    }

    slide( event, ui ){
        console.info( "level slide");
        let value = event;
        if( event.target )
            value = this.slider.max-parseInt( event.target.value );
        let elem = document.getElementById( "level_slider_value" );
        if( elem ) elem.innerHTML = "[" + this.levels[value] + "]";
    }
}
